<template>
  <div class="container-fluid">
    <div class="contents setting">
      <tab />

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-5"
          role="tabpanel"
          aria-labelledby="pills-5-tab"
        >
          <!--           <b-form @submit="onSubmit">
            <div class="filter-box-2">
              <div>
                <select
                  class=""
                  name="searchtype"
                  v-model="searchData.searchtype"
                >
                  <option value="1">제목</option>
                  <option value="2">내용</option>
                </select>
              </div>
              <div class="search-input">
                <input
                  type="text"
                  class="form-control-lg"
                  name="searchname"
                  v-model="searchData.searchname"
                />
                <input
                  class="btn btn-primary btn-lg icon-search"
                  type="submit"
                  value=""
                />
              </div>
            </div>
          </b-form> -->

          <b-form @submit="onSubmit">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-auto g-2 mb-4">
              <div class="col-12">
                <select
                  class=""
                  name="searchtype"
                  v-model="searchData.searchtype"
                >
                  <option value="1">{{ $t("filter.common.title") }}</option>
                  <option value="2">{{ $t("filter.common.contents") }}</option>
                </select>
              </div>

              <div class="col">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    name="searchname"
                    v-model="searchData.searchname"
                  />
                  <button
                    class="btn btn-primary btn-lg icon-search"
                    type="submit"
                  ></button>
                </div>
              </div>
            </div>
          </b-form>

          <table class="table board toggle-xl">
            <thead>
              <tr>
                <th class="col-auto d-none d-xl-table-cell w-1">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto w-1">
                  {{ $t("title.common.category") }}
                </th>
                <th class="col-auto">{{ $t("title.common.title") }}</th>
                <th class="col-auto d-none d-md-table-cell">
                  {{ $t("title.common.date") }}
                </th>
                <th class="col-auto d-none d-xl-table-cell w-1">
                  {{ $t("title.setting.view_count") }}
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="data_yn">
              <template v-for="(item, index) in items">
                <tr :key="index">
                  <td class="col-auto d-none d-xl-table-cell w-1">
                    {{ item.no }}
                  </td>
                  <td class="col-auto w-1">
                    <span class="icon badge bg-purple" v-if="item.type === '1'">
                      {{ $t("title.setting.notice") }}
                    </span>
                    <span class="icon badge bg-blue" v-if="item.type === '2'">
                      {{ $t("title.setting.patch") }}
                    </span>
                  </td>
                  <td class="col-auto text-start">
                    <router-link
                      class="more"
                      :to="{
                        name: 'NoticeView',
                        params: { noticeno: item.noticeno },
                        query: {
                          searchtype: searchData.searchtype,
                          searchname: searchData.searchname,
                        },
                      }"
                      >{{ item.title }}</router-link
                    >
                  </td>
                  <td class="col-auto d-none d-md-table-cell text-date">
                    {{ item.timezone_date | dateformat }}
                  </td>
                  <td class="col-auto d-none d-xl-table-cell w-1">
                    {{ item.cnt | comma }}
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="d-xl-none"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r'"
                  v-if="view_hide === index"
                >
                  <td colspan="6">
                    <!--
                    <router-link
                      :to="{
                        name: 'NoticeView',
                        params: { noticeno: item.noticeno },
                      }"
                      class="btn_view"
                    >
                      <img src="/img/ico_edit.png" />
                    </router-link>
                    -->
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.number") }}</div>
                        <div class="col-8">{{ item.no }}</div>
                      </div>
                      <!--                       <div class="row">
                        <div class="col-6">
                          {{ $t("title.common.category") }}
                        </div>
                        <div class="col-6">
                          <span
                            class="icon badge bg-purple"
                            v-if="item.type === '1'"
                          >
                            {{ $t("title.setting.notice") }}
                          </span>
                          <span
                            class="icon badge bg-blue"
                            v-if="item.type === '2'"
                          >
                            {{ $t("title.common.patch") }}
                          </span>
                        </div>
                      </div> -->
                      <div class="row d-md-none">
                        <div class="col-4">{{ $t("title.common.date") }}</div>
                        <div class="col-8 text-date">
                          {{ item.timezone_date | dateformat }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.setting.view_count") }}
                        </div>
                        <div class="col-8">{{ item.cnt | comma }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Page navigation example"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text
              ><i class="material-icons"
                >keyboard_double_arrow_right</i
              ></template
            >
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/setting";
import tab from "@/components/setting/Tab";

export default {
  name: "Notice",
  components: {
    tab,
  },
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_ownernoticelist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_ownernoticelist();
    },

    "searchData.pageno": function () {
      this.get_ownernoticelist();
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.get_ownernoticelist();
    },
    get_ownernoticelist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_ownernoticelist(this.searchData, (flag, data) => {
        if (flag) {
          if (data.noticelistcnt <= 0) {
            this.data_yn = false;
            return false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.noticelistcnt;
          this.page_total = Math.ceil(data.noticelistcnt / this.rows);
          this.items = data.noticelist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return pageNum === 1
        ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
        : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_ownernoticelist();
  },
};
</script>
